import React, { Component } from 'react';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import './DeviceVersionView.css';
import { connect } from 'react-redux';
import {
  getSingleDevice,
  updateSoftware,
  updateSingleDevicePageSwVersionModal,
  updateSoftwareUpdateStatuses,
  setSoftwareUpdateStatusUrl,
  setSoftwareUpdateStatus,
  doGetProductTypesList
} from 'redux/actions';
import { PERMISSION_ERROR_MESSAGE, Status } from 'common/utils/constants';
import moment from 'moment';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import {
  getDeviceSwVersion,
  swVersionCompare,
  getNumericArraySwVersion,
  getMatchingSwVersions,
  hasCMSwUpdatePermission
} from 'common/utils/helpers';
import SoftwareDownloadModal from 'components/features/SoftwareDownloadModal/SoftwareDownloadModal';
import { IconLoader } from 'common/IconLoader';

// const sw_versions = [
//     "1.0.2",
//     "1.0.0",
//     "0.4.2",
//     "0.4.0",
//     "0.3.6",
//     "0.3.4",
//     "0.3.2",
//     "0.3.0",
//     "0.2.2",
//     "0.2.0",
// ]

const UpdateEnum = {
  INIT: null,
  SCHEDULED: 'scheduled',
  QUEUEING: 'queueing',
  DOWNLOADING: 'downloading',
  REBOOTING: 'rebooting',
  COMPLETED: 'completed',
  ERROR: 'error',
  FAILED: 'failed',
  WARNING: 'warning',
  SCHEDULED_ACTIVATION: 'scheduled_activation'
};

class SoftwareDownloadStatusBar extends Component {
  render() {
    try {
      if (!this.props.device || !this.props.softwareUpdateStatuses) {
        return <div>No Device</div>;
      }

      let statusQueryGetUri = this.props.device?.tags?.iotHubDM?.softwareDownload?.statusQueryGetUri;
      let runtimeStatus = null;
      let status = null;
      let info = null;
      let msg = null;

      if (this.props.softwareUpdateStatuses[this.props.device.id] != null) {
        status = this.props.softwareUpdateStatuses[this.props.device.id].status;
        info = this.props.softwareUpdateStatuses[this.props.device.id].status_info;
        msg = this.props.softwareUpdateStatuses[this.props.device.id].message;
      }

      runtimeStatus = this.props.softwareUpdateStatuses?.[this.props.device.id]?.runtimeStatus?.toLowerCase();
      if (
        (statusQueryGetUri &&
          runtimeStatus &&
          runtimeStatus === UpdateEnum.COMPLETED &&
          status === UpdateEnum.SCHEDULED) ||
        (runtimeStatus && runtimeStatus === UpdateEnum.COMPLETED && !status)
      ) {
        status = UpdateEnum.COMPLETED;
      }

      switch (status) {
        case UpdateEnum.INIT:
          return (
            <div className="SoftwareDownloadStatusBar_OuterDiv">
              <div className="SoftwareDownloadStatusBar_DoneOuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                  <img
                    className="SoftwareDownloadStatusBar_IconInit"
                    src={IconLoader.icon_init}
                    alt={'initializing icon'}
                  />
                </div>
                <div className="SoftwareDownloadStatusBar_DoneInnerDiv">
                  <div className="SoftwareDownloadStatusBar_RetrieveInfoDiv">
                    <span className="SoftwareDownloadStatusBar_InstallText">Gathering software download info...</span>
                  </div>
                </div>
              </div>
            </div>
          );
        case UpdateEnum.SCHEDULED:
          let sched = 'Unknown';
          if (info != null && info.schedule != null) {
            try {
              sched = moment(info.schedule).format('ddd, MMM Do YYYY, h:mm a');
            } catch (error) {
              console.log('error creating moment:', error);
              sched = info.schedule;
            }
          }

          let schedDiv = <div />;

          if (
            this.props.softwareUpdateStatuses != null &&
            this.props.softwareUpdateStatuses[this.props.device.id] != null
          )
            schedDiv = (
              <div className="SoftwareDownloadStatusBar_OuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledOuterDiv">
                  <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                    <img src={IconLoader.icon_scheduling} alt={'scheduled icon'} />
                  </div>
                  <div className="SoftwareDownloadStatusBar_ScheduledInnerDiv">
                    <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                      <span className="SoftwareDownloadStatusBar_InstallText">
                        Version{' '}
                        <span className="SoftwareDownloadStatusBar_InstallText SoftwareDownloadStatusBar_VersionText">
                          {this.props.softwareUpdateStatuses[this.props.device.id].version}
                        </span>{' '}
                        scheduled to be downloaded to device on:{' '}
                      </span>
                    </div>
                    <div>
                      <div className="SoftwareDownloadStatusBar_ScheduleText">{sched}</div>
                    </div>
                  </div>
                </div>
              </div>
            );

          return schedDiv;

        case UpdateEnum.SCHEDULED_ACTIVATION:
          let sched_activation = 'Unknown';
          if (info != null && info.schedule != null) {
            try {
              sched_activation = moment(info.schedule).format('ddd, MMM Do YYYY, h:mm a');
            } catch (error) {
              console.log('error creating moment:', error);
              sched_activation = info.schedule;
            }
          }

          let schedActivationDiv = <div />;

          if (
            this.props.softwareUpdateStatuses != null &&
            this.props.softwareUpdateStatuses[this.props.device.id] != null
          )
            schedActivationDiv = (
              <div className="SoftwareDownloadStatusBar_OuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledOuterDiv">
                  <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                    <img src={IconLoader.icon_scheduling} alt={'scheduled icon'} />
                  </div>
                  <div className="SoftwareDownloadStatusBar_ScheduledInnerDiv">
                    <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                      <span className="SoftwareDownloadStatusBar_InstallText">
                        Version{' '}
                        <span className="SoftwareDownloadStatusBar_InstallText SoftwareDownloadStatusBar_VersionText">
                          {this.props.softwareUpdateStatuses[this.props.device.id].version}
                        </span>{' '}
                        is scheduled to be activated on device on:{' '}
                      </span>
                    </div>
                    <div>
                      <div className="SoftwareDownloadStatusBar_ScheduleText">{sched_activation}</div>
                    </div>
                  </div>
                </div>
              </div>
            );

          return schedActivationDiv;

        case UpdateEnum.QUEUEING:
          let queText = 'Queueing installation version: ';

          let queDiv = <div />;

          if (
            this.props.softwareUpdateStatuses != null &&
            this.props.softwareUpdateStatuses[this.props.device.id] != null
          )
            queDiv = (
              <div className="SoftwareDownloadStatusBar_OuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledOuterDiv">
                  <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                    <img src={IconLoader.icon_scheduling} alt={'scheduled icon'} />
                  </div>
                  <div className="SoftwareDownloadStatusBar_ScheduledInnerDiv">
                    <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                      <span className="SoftwareDownloadStatusBar_InstallText">{queText}</span>
                      <span className="SoftwareDownloadStatusBar_InstallText SoftwareDownloadStatusBar_VersionText">
                        {this.props.softwareUpdateStatuses[this.props.device.id].version}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );

          return queDiv;

        case UpdateEnum.DOWNLOADING:
          let prog = 'Unknown';
          if (info != null && info.progress != null) {
            prog = info.progress.toString();
          }

          let downloadingDiv = <div />;

          if (
            this.props.softwareUpdateStatuses != null &&
            this.props.softwareUpdateStatuses[this.props.device.id] != null
          )
            downloadingDiv = (
              <div className="SoftwareDownloadStatusBar_OuterDiv">
                <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                  <span className="SoftwareDownloadStatusBar_InstallText">Installing software version: </span>
                  <span className="SoftwareDownloadStatusBar_InstallText SoftwareDownloadStatusBar_VersionText">
                    {this.props.softwareUpdateStatuses[this.props.device.id].version}
                  </span>
                </div>
                <div className="SoftwareDownloadStatusBar_ProgressBar">
                  <div className="SoftwareDownloadStatusBar_BarSpace" />
                  <div className="SoftwareDownloadStatusBar_BarFilled" style={{ width: prog + '%' }} />
                </div>
                <div className="SoftwareDownloadStatusBar_RemainingTime">
                  <div className="SoftwareDownloadStatusBar_RemainingTimeText">
                    Percent Complete: <mark>{prog}</mark>%{' '}
                  </div>
                </div>
              </div>
            );

          return downloadingDiv;

        case UpdateEnum.REBOOTING:
          return (
            <div className="SoftwareDownloadStatusBar_OuterDiv">
              <div className="SoftwareDownloadStatusBar_DoneOuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                  <img src={IconLoader.icon_rebooting} alt={'rebooting icon'} />
                </div>
                <div className="SoftwareDownloadStatusBar_ScheduledInnerDiv">
                  <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                    <span className="SoftwareDownloadStatusBar_InstallText">Software download is complete</span>
                  </div>
                  <div>
                    <div className="SoftwareDownloadStatusBar_ScheduleText">Device is rebooting...</div>
                  </div>
                </div>
              </div>
            </div>
          );
        case UpdateEnum.ERROR:
          return (
            <div className="SoftwareDownloadStatusBar_ErrorOuterDiv">
              <div className="SoftwareDownloadStatusBar_ErrorScheduledIcon_Div">
                <img src={IconLoader.icon_error} alt={'error icon'} />
              </div>
              <div className="SoftwareDownloadStatusBar_ErrorInnerDiv">
                <div className="SoftwareDownloadStatusBar_ErrorText">{msg}</div>
              </div>
              <div className="SoftwareDownloadStatusBar_X_Div">
                <SvgAF
                  img={IconLoader.icon_close_circle}
                  hover={IconLoader.icon_close_circle_hover}
                  onClick={this.props.close}
                />
              </div>
            </div>
          );
        case UpdateEnum.FAILED:
          return (
            <div className="SoftwareDownloadStatusBar_ErrorOuterDiv">
              <div className="SoftwareDownloadStatusBar_ErrorScheduledIcon_Div">
                <img src={IconLoader.icon_error} alt={'error icon'} />
              </div>
              <div className="SoftwareDownloadStatusBar_ErrorInnerDiv">
                <div className="SoftwareDownloadStatusBar_ErrorText">{msg}</div>
              </div>
              <div className="SoftwareDownloadStatusBar_X_Div">
                <SvgAF
                  img={IconLoader.icon_close_circle}
                  hover={IconLoader.icon_close_circle_hover}
                  onClick={this.props.close}
                />
              </div>
            </div>
          );
        case UpdateEnum.WARNING:
          return (
            <div className="SoftwareDownloadStatusBar_WarningOuterDiv">
              <div className="SoftwareDownloadStatusBar_WarningScheduledIcon_Div">
                <img src={IconLoader.icon_warning_2} alt={'warning icon'} />
              </div>
              <div className="SoftwareDownloadStatusBar_WarningInnerDiv">
                <div className="SoftwareDownloadStatusBar_WarningText">{msg}</div>
              </div>
              <div className="SoftwareDownloadStatusBar_X_Div">
                <SvgAF
                  img={IconLoader.icon_close_circle}
                  hover={IconLoader.icon_close_circle_hover}
                  onClick={this.props.close}
                />
              </div>
            </div>
          );
        case UpdateEnum.COMPLETED:
          let sw_version_str = getDeviceSwVersion(this.props.device);
          return (
            <div className="SoftwareDownloadStatusBar_SuccessOuterDiv">
              <div className="SoftwareDownloadStatusBar_DoneOuterDiv">
                <div className="SoftwareDownloadStatusBar_ScheduledIcon_Div">
                  <img src={IconLoader.icon_success} alt={'success icon'} />
                </div>
                <div className="SoftwareDownloadStatusBar_DoneInnerDiv">
                  <div className="SoftwareDownloadStatusBar_VersionInfoDiv">
                    <span className="SoftwareDownloadStatusBar_InstallText">Version </span>
                    <span className="SoftwareDownloadStatusBar_InstallText SoftwareDownloadStatusBar_VersionText">
                      {sw_version_str}
                    </span>
                    <span className="SoftwareDownloadStatusBar_InstallText"> has been installed </span>
                  </div>
                </div>
              </div>
              <div className="SoftwareDownloadStatusBar_X_Div">
                <SvgAF
                  img={IconLoader.icon_close_circle}
                  hover={IconLoader.icon_close_circle_hover}
                  onClick={this.props.close}
                  alt={'close icon'}
                />
              </div>
            </div>
          );
        default:
          return null;
      }
    } catch (e) {
      return (
        <div className="SoftwareDownloadStatusBar_ErrorOuterDiv">
          <div className="SoftwareDownloadStatusBar_ErrorScheduledIcon_Div">
            <img src={IconLoader.icon_error} alt={'error icon'} />
          </div>
          <div className="SoftwareDownloadStatusBar_ErrorInnerDiv">
            <div className="SoftwareDownloadStatusBar_ErrorText">{'Unknown BError'}</div>
          </div>
          <div className="SoftwareDownloadStatusBar_X_Div">
            <SvgAF
              img={IconLoader.icon_close_circle}
              hover={IconLoader.icon_close_circle_hover}
              onClick={this.props.close}
            />
          </div>
        </div>
      );
    }
  }
}

/* Device version view handles software downloading on single device page.*/
class DeviceVersionView extends Component {
  constructor(props) {
    super(props);

    this.afterModalClose = this.afterModalClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.installNowOnClick = this.installNowOnClick.bind(this);
    this.pollDevice = this.pollDevice.bind(this);
    this.pollSoftwareUpdateStatus = this.pollSoftwareUpdateStatus.bind(this);
    this.applyScheduleOnClick = this.applyScheduleOnClick.bind(this);

    this.state = {
      modalClosing: false,
      gotDevice: false /* Make sure to get device once when loading page for fresh info*/,
      animateModalClose: false,
      downloadModalPage: 'LIST',
      softwareUpdating: false /* This is set to true when a software download is in progress, and set to false when the download status is completed */,
      softwareUpdateInitiated: false /* This is set to true when a software download is started or in progress, and remains true after download finishes
                                               It signifies that the download status needs to be displayed */,
      blockedUpdateUrl: null /* After status box is closed by clicking X, we need to blacklist the update url. 
                                       Otherwise the state will go back to updating because the url is saved*/,
      availableSwVersionList: null
    };

    this.pollSoftwareUpdateStatus = this.pollSoftwareUpdateStatus.bind(this);
  }

  componentWillUnmount() {
    try {
      console.log('Unmounting device version view for', this.props.device.id);
      this.pollingSoftwareUpdateStatus = false;
      this.pollingDevice = false;
    } catch (e) {}
  }

  pollDevice() {
    if (!this.pollingDevice) {
      return;
    }

    /* Might want to use like a semaphore here to make sure that we don't end up with multiples of this loop*/
    /* Or handle device polling at a higher level*/
    setTimeout(() => {
      if (!this.pollingDevice) {
        return;
      }
      if (this.props.statuses['GET-' + this.props.device.id] !== Status.PENDING) {
        console.log('get device status:', this.props.statuses['GET-' + this.props.device.id]);
        this.props.dispatch(getSingleDevice(this.props.device.id));
      }
      this.pollDevice();
    }, 30000);
  }

  pollSoftwareUpdateStatus() {
    console.log('In pollSoftwareUpdateStatus');
    if (!this.pollingSoftwareUpdateStatus) {
      return;
    }

    // if(!this.props.device.tags || !this.props.device.tags.iotHubDM || !this.props.device.tags.iotHubDM.softwareDownload ||
    //    !this.props.device.tags.iotHubDM.softwareDownload.statusQueryGetUri)
    // {
    // //    /* no url to check, software is therefore not updating*/
    //     No status query URI, therefore no software download happening");
    //     this.setState({softwareUpdating:false});
    //     this.pollingSoftwareUpdateStatus = false;
    //     return;
    // }
    let status = this.props.softwareUpdateStatuses[this.props.device.id];
    if (
      status != null &&
      (status.runtimeStatus === 'Completed' || status.runtimeStatus === 'Failed' || status.runtimeStatus === 'Warning')
    ) {
      console.log('stop polling software update status');
      this.pollingSoftwareUpdateStatus = false;
      if (this.state.softwareUpdating === true) {
        this.props.dispatch(setSoftwareUpdateStatusUrl(this.props.device.id, null));
        this.setState({ softwareUpdating: false });
      }

      return;
    }

    let time = 10000;
    if (status != null && status.customStatus != null && status.customStatus.includes('scheduled')) {
      time = 30000; //if update is in process but is scheduled, set timer to 30 seconds instead of 5
    }

    setTimeout(() => {
      if (!this.pollingSoftwareUpdateStatus) {
        return;
      }
      console.log('Polling on this:', this);

      if (this.props.softwareUpdateStatusUrls[this.props.device.id] == null) {
        //if the device we're polling has no status to poll, stop polling
        this.pollSoftwareUpdateStatus = false;
        return;
      }
      let url = this.props.softwareUpdateStatusUrls[this.props.device.id];
      if (this.props.statuses['SoftwareUpdateStatus-' + url] !== Status.PENDING) {
        console.log('software update call status:', this.props.statuses['SoftwareUpdateStatus-' + url]);
        this.props.dispatch(updateSoftwareUpdateStatuses(url));
      }
      this.pollSoftwareUpdateStatus();
    }, time);
  }

  componentDidMount() {
    this.componentDidUpdate();
    !this.props.productTypesList && this.props.dispatch(doGetProductTypesList());
  }

  componentDidUpdate() {
    //SW info state:", this.state);
    if (this.props.device == null) {
      console.log('device is null');
      return;
    }

    if (this.state.gotDevice === false) {
      this.props.dispatch(getSingleDevice(this.props.device.id));
      this.setState({ gotDevice: true });
    }

    /* If the device has a software update url but our store doesn't, then update the store*/
    if (
      this.props.device.tags &&
      this.props.device.tags.iotHubDM &&
      this.props.device.tags.iotHubDM.softwareDownload &&
      this.props.device.tags.iotHubDM.softwareDownload.statusQueryGetUri
    ) {
      if (this.props.softwareUpdateStatusUrl && this.props.softwareUpdateStatusUrl[this.props.device.id] != null) {
        console.log(
          'New software update status URL:',
          this.props.device.tags.iotHubDM.softwareDownload.statusQueryGetUri
        );
        this.props.dispatch(
          setSoftwareUpdateStatusUrl(
            this.props.device.id,
            this.props.device.tags.iotHubDM.softwareDownload.statusQueryGetUri
          )
        );
      }
    }

    /* If the software download query uri exists, then a software download is in progress */
    if (
      this.props.softwareUpdateStatusUrls[this.props.device.id] != null &&
      this.props.softwareUpdateStatusUrls[this.props.device.id] !== this.state.blockedUpdateUrl
    ) {
      if (this.state.softwareUpdating === false) {
        this.setState({ softwareUpdating: true, softwareUpdateInitiated: true });
      }
      if (!this.pollingSoftwareUpdateStatus) {
        console.log('Starting to poll software update status, device:', this.props.device.id);
        this.pollingSoftwareUpdateStatus = true;
        this.pollSoftwareUpdateStatus();
      }
      if (!this.pollingDevice) {
        /* Device is now always polled in SingleDevicePage */
        // console.log("starting to poll device:", this.props.device.id);
        // this.pollingDevice = true;
        // this.pollDevice();
      }
    }

    if (this.props.productTypesList && !this.state.availableSwVersionList) {
      let availableSwVersionList = getMatchingSwVersions(
        this.props.device,
        this.props.softwareVersions?.['all'],
        this.props.productTypesList
      );
      this.setState({ availableSwVersionList: availableSwVersionList });
    }
  }

  /* Funciton for cleaning up after modal has closed*/
  afterModalClose() {
    this.props.dispatch(updateSingleDevicePageSwVersionModal(false));
    this.setState({ modalClosing: false, animateModalClose: false, downloadModalPage: 'LIST' });
  }

  /* Call this function to initiate closing of the modal with no animation*/
  closeModal() {
    this.setState({ modalClosing: true });
  }

  installNowOnClick(swid) {
    window._mfq = window._mfq || [];
    window._mfq.push(['formSubmitAttempt', '#singleUpgradeForm']);
    /*Replace this dispatch with the proper software download api call once it exists*/
    //this.props.dispatch(patchDeviceParameters(this.props.device.id, {updateProgress:0, softwareUpdating:true}))
    this.props.dispatch(setSoftwareUpdateStatus(this.props.device.id, null));
    this.props.dispatch(updateSoftware(this.props.device.id, swid, 'now'));
    this.setState({ modalClosing: true, animateModalClose: true, softwareUpdateInitiated: true }); //set animateModalClose true so modal will close with pretty animation
  }

  applyScheduleOnClick(swid, datetime) {
    this.props.dispatch(updateSoftware(this.props.device.id, swid, datetime.format()));
    this.setState({ modalClosing: true, animateModalClose: true, softwareUpdateInitiated: true }); //set animateModalClose true so modal will close with pretty animation
  }

  render() {
    let modal = null;
    if (this.props.modalOpen) {
      modal = (
        <SoftwareDownloadModal
          key={0}
          modalTargetRef={this.modalTargetRef} //this is where the modal animation closes towards
          cancelOnClick={this.closeModal} //this runs when the cancel button is clicked. Used to update store that modal has closed
          animateModalClose={this.state.animateModalClose} //this determines whether closing modal performs animation
          afterModalClose={this.afterModalClose} //this will run after modal closes and make sure state is correct
          closeModal={this.state.modalClosing} //when this is set to true, it will instruct the modal to close
          installNowOnClick={this.installNowOnClick}
          applyScheduleOnClick={this.applyScheduleOnClick}
          softwareVersions={this.props.softwareVersions}
          device={this.props.device}
          availableSwVersionList={this.state.availableSwVersionList}
        />
      );
    }

    if (this.props.device == null) {
      return <ConsoleTile data-tip="SW/HW version" />;
    }

    let sw_version_str = '';
    sw_version_str += getDeviceSwVersion(this.props.device);
    const latestSwVersion = this.state.availableSwVersionList?.[0]?.sw_version;
    const hasLatestSwVersion = latestSwVersion && sw_version_str && latestSwVersion !== sw_version_str;
    const hasHigherSwVersion = sw_version_str && this.state.availableSwVersionList?.[0]?.sw_version > sw_version_str;

    //test cmp:", this.props.softwareVersions["all"].sort((v1, v2) => swVersionCompare(v2.version_numbers, v1.version_numbers)));
    let newSwVerAvailable;
    let newSwVerAvailableStr;
    try {
      newSwVerAvailable =
        this.state.availableSwVersionList &&
        swVersionCompare(
          getNumericArraySwVersion(getDeviceSwVersion(this.props.device)),
          this.state.availableSwVersionList[0].version_numbers
        ) < 0;
      newSwVerAvailableStr =
        (newSwVerAvailable || hasLatestSwVersion) && hasHigherSwVersion ? 'A new version available' : '';
    } catch (error) {
      newSwVerAvailableStr = '';
    }

    const hasSwUpdatePermission = hasCMSwUpdatePermission(this.props.permissions);

    return (
      <ConsoleTile data-tip="SW/HW Version">
        {this.props.modalOpen ? modal : null}
        <div
          className="DeviceVersionView"
          ref={(ref) => {
            this.viewRef = ref;
          }}
        >
          <div className="DeviceVersionView_InnerDiv">
            <table>
              <tbody>
                <tr>
                  <td className="DeviceVersionView_Header_Cell">Software version:</td>
                  <td>
                    <div
                      className={'DeviceVersionView_SwVersion'}
                      onClick={() => {
                        console.log('Version info clicked!');
                      }}
                    >
                      <span className={'DeviceVersionView_SwVersionText'} data-tip={sw_version_str}>
                        {sw_version_str}
                      </span>
                      {/* <SvgAF img={IconLoader.icon_note} hover={IconLoader.icon_note_hover} tooltip="view release notes"/> */}
                    </div>
                  </td>
                  <td className="DeviceVersionView_ChangeSwButton" style={{ flex: 5 }}>
                    <button
                      disabled={
                        this.state.softwareUpdating || this.state.softwareUpdateInitiated || !hasSwUpdatePermission
                      }
                      className="Global_ThinBlueButton"
                      onClick={() => {
                        hasSwUpdatePermission && this.props.dispatch(updateSingleDevicePageSwVersionModal(true));
                      }}
                      data-tip={hasSwUpdatePermission ? 'Update/Rollback' : PERMISSION_ERROR_MESSAGE}
                    >
                      Update/Rollback
                    </button>
                  </td>
                </tr>

                {!(this.state.softwareUpdating || this.state.softwareUpdateInitiated) ? (
                  <tr>
                    <td />
                    <td />
                    <td className="DeviceVersionView_NewVersionTag">{newSwVerAvailableStr}</td>
                  </tr>
                ) : null}
                {this.state.softwareUpdating || this.state.softwareUpdateInitiated ? (
                  <tr ref={(ref) => (this.modalTargetRef = ref)}>
                    <td colSpan={3}>
                      <div>
                        <SoftwareDownloadStatusBar
                          device={this.props.device}
                          softwareUpdateStatuses={this.props.softwareUpdateStatuses}
                          key={this.props.device.id + 'downloadStatusBar'}
                          close={() => {
                            this.pollingSoftwareUpdateStatus = false;
                            this.setState({
                              softwareUpdateInitiated: false,
                              softwareUpdating: false,
                              blockedUpdateUrl: this.props.softwareUpdateStatusUrls[this.props.device.id]
                            });
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr ref={(ref) => (this.modalTargetRef = ref)} />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </ConsoleTile>
    );
  }
}

export default connect((store) => {
  return {
    modalOpen: store.ui.singleDevicePage.swVersionModalOpen,
    device: store.ui.singleDevicePage.selectedDevice,
    statuses: store.statuses,
    softwareUpdateStatuses: store.data.softwareUpdateStatuses,
    softwareVersions: store.data.softwareVersions,
    softwareUpdateStatusUrls: store.data.softwareUpdateStatusUrls,
    productTypesList: store.data.productTypesList,
    permissions: store.data.rolePermissions.permissions
  };
})(DeviceVersionView);
